module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-10.2749b829.png";